// Function for get first letter of review author
function updateAuthorInitial() {
  const reviews = document.querySelectorAll('.jdgm-rev')
  const questions = document.querySelectorAll('.jdgm-quest')

  ;[...reviews, ...questions].forEach((item) => {
    const authorElement = item.querySelector('.jdgm-rev__author')
    const iconElement = item.querySelector('.jdgm-rev__icon')

    if (authorElement && iconElement) {
      const authorName = authorElement.textContent.trim()
      const firstLetter = authorName.charAt(0).toUpperCase()

      iconElement.style.setProperty('--author-initial', `'${firstLetter}'`)
    }
  })
}

const observerLetter = new MutationObserver(() => {
  updateAuthorInitial()
})

const config = { childList: true, subtree: true, characterData: true }

observerLetter.observe(document.body, config)

updateAuthorInitial()

// Move summary average to another parent
const observerSummary = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      const child = document.querySelector('.jdgm-rev-widg__summary-average')
      if (child) {
        const newParent = document.querySelector('.jdgm-rev-widg__summary')
        if (newParent) {
          newParent.appendChild(child)
          observerSummary.disconnect()
        }
      }
    }
  }
})

observerSummary.observe(
  document.querySelector('.jdgm-rev-widg__summary-stars'),
  {
    childList: true,
    subtree: true,
  },
)

// Move input to jdgm-rev-widg__sort-wrapper and add new elements
const observerNewElements = new MutationObserver(() => {
  const inputElement = document.querySelector('.jdgm-review-search')
  const parentElement = document.querySelector('.jdgm-rev-widg__sort-wrapper')

  if (
    inputElement &&
    parentElement &&
    !parentElement.querySelector('.jdgm-review-search')
  ) {
    const newDiv = document.createElement('div')
    const clonedElement = inputElement.cloneNode(true)

    newDiv.classList.add('jdgm-search-input')
    newDiv.appendChild(clonedElement)
    parentElement.appendChild(newDiv)

    const jdgmSubTab = document.querySelector('.jdgm-subtab')
    const searchInput = document.querySelector('.jdgm-search-input')

    searchInput.insertAdjacentElement('afterend', jdgmSubTab)
  }
})

observerNewElements.observe(document.body, {
  childList: true,
  subtree: true,
})

function updatePaginationText() {
  const paginationLinks = document.querySelectorAll(
    '.jdgm-paginate__next-page, .jdgm-paginate__prev-page',
  )

  paginationLinks.forEach((link) => {
    if (
      link.classList.contains('jdgm-paginate__next-page') &&
      !link.textContent.includes('Next')
    ) {
      link.textContent = 'Next'
    }

    if (
      link.classList.contains('jdgm-paginate__prev-page') &&
      !link.textContent.includes('Prev')
    ) {
      link.textContent = 'Prev'
    }
  })
}

const observerPagination = new MutationObserver(() => {
  updatePaginationText()
})

observerPagination.observe(document.body, {
  childList: true,
  subtree: true,
})
